import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 空运航班信息管理-查询列表
export function queryAirFlightInfo(data) {
  return request({
    url: URL.price.airFlightInfo.queryAirFlightInfo,
    method: 'post',
    data
  })
}
// 空运航班信息管理-保存
export function saveAirFlightInfo(data) {
  return request({
    url: URL.price.airFlightInfo.saveAirFlightInfo,
    method: 'post',
    data
  })
}
// 空运航班信息管理-删除
export function deleteAirFlightInfo(data) {
  return request({
    url: URL.price.airFlightInfo.deleteAirFlightInfo,
    method: 'post',
    data
  })
}

// 空运运价-查询航班号
export function queryAllAirFlightNo(params) {
  return request({
    url: URL.price.airFlightInfo.queryAllAirFlightNo,
    method: 'get',
    params
  })
}
